import { render, staticRenderFns } from "./RelatedResourceServer.vue?vue&type=template&id=51eb9901"
import script from "./RelatedResourceServer.vue?vue&type=script&lang=js"
export * from "./RelatedResourceServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports